import { render, staticRenderFns } from "./CardTicketView.vue?vue&type=template&id=49f34f6a"
import script from "./CardTicketView.vue?vue&type=script&lang=js"
export * from "./CardTicketView.vue?vue&type=script&lang=js"
import style0 from "./CardTicketView.vue?vue&type=style&index=0&id=49f34f6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports